import type { CasOrCategory } from '../types/db.ts';

export const emissionsCategories = new Set<CasOrCategory>([
  'PM',
  'PM10',
  'PM2.5',
  'PM Filterable',
  'PM10 Filterable',
  'PM2.5 Filterable',
  'PM Condensable',
  'VOC',
  'CO2e',
  'F',
  'NOx',
  'SOx',
] as CasOrCategory[]);

export function categoryIsValid(category: string): boolean {
  return /^N\d{3}$/.test(category) || emissionsCategories.has(category as CasOrCategory);
}
